// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"MessageWindow_messageContainer__30wb-","scrollWindow":"MessageWindow_scrollWindow__3SY8o","scrollDown":"MessageWindow_scrollDown__1z3Al"};